module.exports = __webpack_public_path__ + "img/bat.3cafacdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bat.jpg
// module id = To3w
// module chunks = 0